import React from 'react'
import { StyledLabel } from '../../assets/styledComponents/Global'
import { useTheme } from 'styled-components'
import ClockIcon from '../../app/components/svgIcons/ClockIcon'
import StyledToolTip from '../../app/components/styledComponents/StyledToolTip'
import moment from 'moment'

const AssessmentHeader = ({ videoProfileRes, timeLeft }) => {
  const theme = useTheme()
  const formatTime = (seconds) => {
    if (!seconds) return "No limit";
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };
  return (
    <div className='bg-white p-3 d-flex justify-content-between align-items-center'>
      <StyledLabel
        size="20px"

        fontWeight="400"
        color={theme?.darktext}
        className="mb-3 font-fredoka fw-normal"
      >
        {videoProfileRes?.videoApplication?.videoProfile?.title}
      </StyledLabel>

      {videoProfileRes?.videoApplication?.allowedTime ? (
        <div className="d-flex align-items-center gap-2">
          <StyledToolTip
            title={'Overall time allocated for the video interview'}
            // className="mt-2"
            placement="top"
          >

            <ClockIcon color={theme?.darktext} size={17} />
          </StyledToolTip>
          <StyledLabel size="15px" fontWeight="500" color={theme?.subText}>
            {timeLeft ? formatTime(timeLeft) : "No time limit"}
          </StyledLabel>
        </div>
      ) :
        <div className="d-flex align-items-center gap-2">
          <StyledToolTip
            title={`${moment(videoProfileRes?.videoApplication?.expireAt).fromNow(true) + " (" + moment(videoProfileRes?.videoApplication?.expireAt).format("Do MMM, h:mm A") + ")"}`}
            // className="mt-2"
            placement="bottom"
          >

            <ClockIcon color={'white'} size={17} className='me-2' />
            <StyledLabel size="15px" fontWeight="500" color={theme?.white}>
              {moment(videoProfileRes?.videoApplication?.expireAt).fromNow(true)}
            </StyledLabel>
          </StyledToolTip>
        </div>
      }
    </div>
  )
}

export default AssessmentHeader